export * as editor from '@wix/auto_sdk_urls_editor/schemas';
export * as site from '@wix/auto_sdk_urls_site/schemas';
